module.exports = __webpack_public_path__ + "img/button_sudu.d9011138.png";